import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { StateProvider, SnackbarProvider } from '@durlabh/dframework-ui';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LicenseInfo } from '@mui/x-license';
import coreConfig from './common/coreConfig.js';

LicenseInfo.setLicenseKey('41a56ea946317381f01fba792a813161Tz0xMTQxMjYsRT0xNzgxODI3MTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y');
createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <SnackbarProvider SnackbarProps={{ autoHideDuration: 4000 }}>
      <StateProvider apiEndpoints={coreConfig.apiEndpoints}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <App />
        </LocalizationProvider>
      </StateProvider>
    </SnackbarProvider>
  </React.StrictMode>
);